import React, { useEffect } from 'react'
import { useAgency } from '@/contexts/AgencyContext'
import { usePageTitle } from '@/hooks/usePageTitle'

interface AgencyLoaderProps {
  children: React.ReactNode
}

export const AgencyLoader: React.FC<AgencyLoaderProps> = ({ children }) => {
  const { agency, loading, error } = useAgency()

  usePageTitle({
    agencyName: agency?.company_name,
    pageTitle: loading ? 'Carregando...' : error ? 'Erro' : undefined
  })

  useEffect(() => {
    const TRANSPARENT_PIXEL =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = agency?.logo_url || TRANSPARENT_PIXEL;
  }, [agency?.logo_url]);

  if (loading) {
    return (
      <div className="w-full h-dvh flex items-center justify-center bg-gray-400">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-neutral-600 border-t-neutral-50 rounded-full animate-spin"></div>
          <p className="text-neutral-50 text-lg">Carregando agência...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="w-full h-dvh flex items-center justify-center bg-gray-400">
        <div className="max-w-md mx-auto p-6 bg-neutral-600 rounded-lg border border-red-500/30">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-neutral-50">{error}</h2>
          </div>
        </div>
      </div>
    )
  }

  if (!agency) {
    return (
      <div className="w-full h-dvh flex items-center justify-center bg-gray-400">
        <div className="max-w-md mx-auto p-6 bg-neutral-600 rounded-lg">
          <div className="flex flex-col items-center gap-4 text-center">
            <h2 className="text-xl font-semibold text-neutral-50">Agência Não Encontrada</h2>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}